function translateRectangle(rect, delta) {
  return {
    ...rect,
    x: rect.x + delta.x,
    y: rect.y + delta.y,
    width: rect.width,
    height: rect.height,
  };
}

export default translateRectangle;
